import styled from 'styled-components';
import { baseInputStyles } from 'elements/inputs/BaseField.styled';

export const Input = styled.input`
  ${baseInputStyles};
`;
